module.exports = __webpack_public_path__ + "img/thumb-004-04.a0979779.png";